module.exports = __webpack_public_path__ + "static/media/3.3c81eda1.jpg";